import { ChipRemovable as UIChipRemovable } from "@webmotors/eleanor-ui";

export interface ChipRemovableProps
  extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  label: string;
  onRemove?: (event?: React.MouseEvent<HTMLElement>) => void;
  showIcon?: boolean;
  size?: "small" | "medium";
  state?: "disabled" | "active";
  dataQA?: string;
   /**
   * @deprecated variant não está mais sendo utilizado para estilização.
   */
  variant?: 'outline' | 'filled' | 'situational';
}

export function ChipRemovable({
  className,
  label,
  onRemove,
  showIcon = true,
  size = "medium",
  state = "active",
  dataQA,
  ...props
}: ChipRemovableProps) {
  return (
    <UIChipRemovable
      className={className}
      label={label}
      onRemove={onRemove}
      showIcon={showIcon}
      size={size}
      state={state}
      data-qa={dataQA}
      {...props}
    />
  );
}
